import type { ColorStyle } from './styleMapElement';

export const errorPointLine: ColorStyle = {
  radius: 12,
  weight: 2,
  color: '#ffffff',
  fillColor: '#bf3f34',
  fillOpacity: 1
};
export const warningPointLine: ColorStyle = {
  radius: 12,
  weight: 2,
  color: '#ffffff',
  fillColor: '#ecb67f',
  fillOpacity: 1
};
export const goodPointLine: ColorStyle = {
  radius: 12,
  weight: 2,
  color: '#ffffff',
  fillColor: '#438538',
  fillOpacity: 1
};
